import { map, Observable, takeWhile, timer } from 'rxjs';

interface SearchOptions<T = any> {
  arr: T[]; // массив для поиска
  key: keyof T; // ключ у элементов массива для поиска
  childrenKey?: keyof T; // рекурсивный поиск по дочерним элементам
  searchVal: any; // значение для поиска
}

/**
 * Ищет рекурсивно значение в массиве объектов
 *
 * @param options
 */
export function searchInArray<T>(options: SearchOptions<T>): T {
  const { arr, key, childrenKey, searchVal } = options;
  let findedElem: T;
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  arr.some(function iter(elem: T) {
    if (elem[key] === searchVal) {
      findedElem = elem;
      return true;
    }
    return Array.isArray(elem[childrenKey]) && (elem[childrenKey] as any).some(iter);
  });
  return findedElem;
}

/**
 * функция по обратному отсчету
 * https://stackblitz.com/edit/rxjs-challenge-05-solution?file=src%2Fapp%2Fapp.component.ts
 *
 * @param start - начало отсчета (30 секунд по умолчанию)
 */
export function countdownFrom(start: number = 30): Observable<number> {
  return timer(0, 1000).pipe(
    map(index => start - index),
    takeWhile<number>(Boolean, true),
  );
}
